import { Children } from 'react';
import PropTypes from 'prop-types';
import keys from 'lodash/keys';

import { breakpoints } from './breakpoints';
import { useMediaContext } from './context';

const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

const Media = (props) => {
  const context = useMediaContext();

  const test = (breakpoint) => {
    const nonBreakpoint = `non${capitalizeFirstLetter(breakpoint)}`;
    const match = props[breakpoint] && context.media[breakpoint];
    const nonMatch = props[nonBreakpoint] && !context.media[breakpoint];
    return match || nonMatch;
  };

  const matched = keys(breakpoints).reduce(
    (matches, breakpoint) => test(breakpoint) || matches,
    false,
  );

  if (!matched) {
    return null;
  }
  return Children.only(props.children);
};

Media.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Media;
